export default __webpack_public_path__ + "static/media/pg.8957a2a2.svg";